module.exports = {
  configureWebpack: {
    devtool: 'source-map'
  },
  runtimeCompiler: true,
  pages: {
    index: {
      entry: 'src/main.js',
      template: 'src/index.html',
      title: "Regesta Pomeraniae Monastica"
    }
  },

  publicPath: process.env.NODE_ENV === 'production'
  ? '/r/regestapomeraniae'
    : '/',

  devServer: {
    overlay: {
      warnings: true,
      errors: true
    }
  },

  lintOnSave: process.env.NODE_ENV !== 'production',

  pluginOptions: {
    i18n: {
      locale: 'de',
      fallbackLocale: 'de',
      localeDir: 'locales',
      enableInSFC: false
    }
  }
}
